module.exports = __webpack_public_path__ + "assets/img/website-logo_109.01aae53a.png";